import React, { ReactElement, useEffect } from 'react';
import { Loader } from 'idsk-react-components';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { useLocation, useParams } from 'react-router';
import routes from '../../../routing/routes';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import DolezitostAktEu from '../../../module/PracovnyKrok/DolezitostAktEu/DolezitostAktEu';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import SuccessMessages from '../../../module/SuccessMessages';

const DolezitostAktEuPage = (): ReactElement => {
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.DEFINOVAT_STUPEN_DOLEZITOSTI);
  const location = useLocation();
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: 'Legislatívne procesy',
          to: routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Definovanie stupňa dôležitosti návrhu aktu EÚ',
          to: location.pathname,
        }]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={materialDetail?.hasPracovnyKrokInZasobnikPrace}
          hasOpravneniePracovneKroky={materialDetail?.hasOpravneniePracovneKroky}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Definovanie stupňa dôležitosti návrhu aktu EÚ"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                />
                <DolezitostAktEu materialDetail={materialDetail} />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default DolezitostAktEuPage;
